class MiniCartController extends window.StimulusController {
  static values = {
    itemsInCart: Number,
  };

  static targets = ["cartItems", "cartItemsList"];
  static outlets = ["main-cart-items"];

  #itemsInCartQuantity = this.itemsInCartValue;

  connect() {
    this.#handleCounter(this.itemsInCartValue);
    document.addEventListener("click", this.#handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.#handleClickOutside);
  }

  #updateQuantity(quantity, shouldOverrideQuantity) {
    if (shouldOverrideQuantity) {
      this.#itemsInCartQuantity = quantity;
    } else {
      this.#itemsInCartQuantity += parseInt(quantity);
    }

    return this.#handleCounter(this.#itemsInCartQuantity);
  }

  #handleCounter(itemsInCart) {
    if (itemsInCart === 0) {
      return this.cartItemsTarget.classList.add("tw-hidden");
    }

    this.cartItemsTarget.classList.remove("tw-hidden");
    this.cartItemsTarget.textContent = itemsInCart;
  }

  #handleClickOutside = (event) => {
    const isHidden =
      this.cartItemsListTarget.classList.contains("tw-opacity-0");

    if (isHidden) {
      return;
    }

    if (!this.element.contains(event.target)) {
      this.toggleMiniCartVisibility();
    }
  };

  #scrollToLatestAddedItem = (id) => {
    const latestAddedItem = this.cartItemsListTarget.querySelector(
      `[data-item-id="${id}"]`,
    );
    if (latestAddedItem) {
      latestAddedItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  toggleMiniCartVisibility(e) {
    e?.preventDefault();

    this.cartItemsListTarget.classList.toggle("tw-opacity-0");
    this.cartItemsListTarget.classList.toggle("tw-pointer-events-none");
  }

  async #fetchMiniCartData() {
    const url = `${window.Shopify.routes.root}?view=mini-cart`;

    const response = await fetch(url);
    return response.text();
  }

  async updateCart(event) {
    const { quantity, shouldOverrideQuantity, hideMiniCart, id } = event.detail;

    this.#updateQuantity(quantity, shouldOverrideQuantity);

    this.cartItemsListTarget.innerHTML = await this.#fetchMiniCartData();

    this.#scrollToLatestAddedItem(id);

    if (this.hasMainCartItemsOutlet) {
      this.mainCartItemsOutlet.refresh();
    }

    if (!hideMiniCart) {
      this.toggleMiniCartVisibility();
    }
  }

  async deleteItem(event) {
    const response = await fetch(event.detail.url, {
      headers: { Accept: "application/json" },
    });

    if (response.ok) {
      const { item_count } = await response.json();

      if (item_count === 0) {
        this.toggleMiniCartVisibility();
      }

      this.cartItemsListTarget.innerHTML = await this.#fetchMiniCartData();

      this.#updateQuantity(item_count, true);

      if (this.hasMainCartItemsOutlet) {
        return this.mainCartItemsOutlet.refresh();
      }
    }

    return console.error(response);
  }
}

Stimulus.register("miniCart", MiniCartController);
